import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Landing route for school SSO (e.g. SSM parent portal).
 * The backend redirects here with ?token=<knoozy_jwt>. We establish the session
 * in memory and navigate client-side (NO full-page reload), so it works reliably
 * on iOS Safari, which can drop localStorage written during an SSO redirect + reload.
 */
const SsoCallback: React.FC = () => {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const run = async () => {
      const token = new URLSearchParams(window.location.search).get('token');
      if (!token) {
        navigate('/auth', { replace: true });
        return;
      }
      try {
        await loginWithToken(token);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('SSO login failed:', err);
        navigate('/auth', { replace: true });
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 flex items-center justify-center">
      <div className="text-center">
        <div className="text-6xl mb-4 animate-bounce">📚</div>
        <h1 className="text-3xl font-bold text-indigo-800 mb-2">Knoozy</h1>
        <p className="text-indigo-600">Signing you in…</p>
      </div>
    </div>
  );
};

export default SsoCallback;
